import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getReportToken } from "services/utils";

// different from normal PrivateRoute, ReportRoute is meant to allow us to show a specific report
// to a user without them being logged in, but only if they have a valid report jwt token
// if they are logged in, this component behaves exactly like the regular PrivateRoute
// even if they maliciously manipulate the reportId in the token, backend won't allow it to be fetched, so it's safe

function parseJwt(token) {
  const [, payloadB64] = token.split(".");
  const base64 = payloadB64.replace(/-/g, "+").replace(/_/g, "/");
  const json = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
      .join(""),
  );
  return JSON.parse(json);
}

export default function ReportRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const { reportId } = props.match.params;

        if (rest.isAuth) {
          return <Component {...props} />;
        }

        const token = getReportToken();
        if (token) {
          try {
            const payload = parseJwt(token);
            if (payload.reportId === reportId) {
              return <Component {...props} />;
            }
          } catch (e) {
            return (
              <Redirect
                to={{
                  pathname: "/signin",
                  destinationRoute: props.location.pathname,
                }}
              />
            );
          }
        }

        return (
          <Redirect
            to={{
              pathname: "/signin",
              destinationRoute: props.location.pathname,
            }}
          />
        );
      }}
    />
  );
}
